import { configureStore } from "@reduxjs/toolkit";
import addJobReducer from "../features/AddNewJob/AddNewJobSlice";
import deleteJobReducer from "../features/DeleteJobs/DeleteJobSlice";
import FetchAllJobsReducer from "../features/FetchAllJobs/FetchAllJobsSlice";
import SingleJobReducer from "../features/GetSingleJob/GetSingleJobSlice";

export const store = configureStore({
    reducer: {
        allJobs: FetchAllJobsReducer ,
        addJob: addJobReducer,
        getSingleJob: SingleJobReducer,
        deleteConfirmation: deleteJobReducer
    },
});
